import FreelancerUserPaymentMethodEnum from '../../../../Enums/FreelancerUserPaymentMethodEnum';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import EditFreelancerUserHelper from '../EditFreelancerUserHelper';

export default class PaymentInformationForDubai {
  //#region Validation
  static validityCheckerForPISwiftIFSCCode(e, editedItem) {
    if (ValidityHelper.forRequiredTextField(editedItem.PISwiftIFSCCode) === '') {
      return ValidityHelper.forMinimumLengthField(e, 6);
    }
    return ValidityHelper.forRequiredTextField(editedItem.PISwiftIFSCCode);
  }
  //#endregion

  static returnDescriptionTab() {
    return {
      label: 'Dubai Payment Information',
      hide: (item) => EditFreelancerUserHelper.isBillingDetailHidden(item, 13),
      fields: [
        {
          fieldName: 'PaymentCurrencyId',
          label: 'Payment Currency',
          className: 'col-6',
          type: InputTypesEnum.CurrencySelect,
          selectvalues: [1, 151],
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'PaymentMethod',
          label: 'Payment Method',
          className: 'col-6',
          type: InputTypesEnum.Select,
          selectvalues: EditFreelancerUserHelper.getPaymentMethodSelectOptions,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'PIPaypalWiseWesternUnionEmail',
          label: 'PayPal Email',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forEmailRequired,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, [FreelancerUserPaymentMethodEnum.PayPal]),
        },
        {
          fieldName: 'PIAccountHolderName',
          label: 'Name of the Account',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, FreelancerUserPaymentMethodEnum.BankTransfer),
        },
        {
          fieldName: 'PIBankAddress',
          label: 'Bank Address',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, FreelancerUserPaymentMethodEnum.BankTransfer),
        },
        {
          fieldName: 'PIBankName',
          label: 'Bank Name',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, FreelancerUserPaymentMethodEnum.BankTransfer),
        },
        {
          fieldName: 'PISwiftIFSCCode',
          label: 'Bank Swift/BIC Code',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: PaymentInformationForDubai.validityCheckerForPISwiftIFSCCode,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, FreelancerUserPaymentMethodEnum.BankTransfer),
        },
        {
          fieldName: 'PIBankAccountNumber',
          label: 'Account Number',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: (e, item) =>
            item.PIABARoutingNumber ? ValidityHelper.AlwaysFlawless(e) : ValidityHelper.forRequiredTextField(e),
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, FreelancerUserPaymentMethodEnum.BankTransfer),
        },
        {
          fieldName: 'PIABARoutingNumber',
          label: 'ABA Routing Number',
          className: 'col-6',
          type: InputTypesEnum.Number,
          validityChecker: (e) => ValidityHelper.forNumberLengthCheck(e, 9),
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, FreelancerUserPaymentMethodEnum.BankTransfer),
        },
        {
          fieldName: 'PIIBANCodeBankAccountNumber',
          label: 'IBAN Code',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, FreelancerUserPaymentMethodEnum.BankTransfer),
        },
      ],
    };
  }
}
